<script lang="ts">
  import { GraphicBlock } from '@reuters-graphics/graphics-components';
  import { assets } from '$app/paths';

  let { notes } = $props();
</script>

<GraphicBlock width="wide" {notes}>
  <div class="videos">
    <video src="{assets}/videos/post14/oil1.mp4" autoplay muted loop playsinline
    ></video>
    <video src="{assets}/videos/post14/oil2.mp4" autoplay muted loop playsinline
    ></video>
    <video src="{assets}/videos/post14/oil3.mp4" autoplay muted loop playsinline
    ></video>
  </div>
</GraphicBlock>

<style>
  .videos {
    display: flex;
    gap: 5px;
  }
  .videos video {
    flex: 1;
    min-width: 0;
  }
</style>
